import { useState } from 'react';
import { useScrollReveal } from '@/hooks/useScrollReveal';

interface GalleryImage {
  src: string;
  alt: string;
  category: string;
}

const galleryImages: GalleryImage[] = [
  {
    src: 'https://readdy.ai/api/search-image?query=Charming%20boutique%20hotel%20exterior%20white%20building%20with%20olive%20green%20shutters%2C%20stone%20pathway%2C%20Mediterranean%20garden%20with%20bougainvillea%20flowers%2C%20warm%20sunlight%2C%20serene%20peaceful%20atmosphere%2C%20editorial%20travel%20photography%20high%20detail&width=600&height=800&seq=gal-hotel-01&orientation=portrait',
    alt: 'İlkim Butik Otel Dış Görünüm',
    category: 'Otel',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Bright%20boutique%20hotel%20room%20interior%20with%20queen%20bed%20crisp%20white%20linens%20natural%20wood%20furniture%20olive%20green%20accent%20pillows%20large%20window%20garden%20view%2C%20warm%20morning%20light%20clean%20minimal%20design%20serene%20peaceful%20atmosphere%20editorial%20interior%20photography%20high%20detail&width=600&height=800&seq=gal-room-01&orientation=portrait',
    alt: 'Standart Oda',
    category: 'Odalar',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20boutique%20hotel%20swimming%20pool%20turquoise%20water%20surrounded%20by%20green%20palm%20trees%20white%20sun%20loungers%20stone%20terrace%20warm%20summer%20afternoon%20light%20peaceful%20relaxation%20atmosphere%20Mediterranean%20garden%20setting%20editorial%20travel%20photography%20high%20detail&width=600&height=800&seq=gal-pool-01&orientation=portrait',
    alt: 'Havuz',
    category: 'Havuz',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Traditional%20Turkish%20serpme%20breakfast%20table%20with%20fresh%20organic%20cheese%20olives%20tomatoes%20cucumbers%20honey%20bread%20tea%20in%20garden%20setting%20green%20nature%20background%20warm%20morning%20sunlight%20rustic%20aesthetic%20editorial%20food%20photography%20high%20detail%20colorful%20fresh%20local%20produce&width=600&height=800&seq=gal-breakfast-01&orientation=portrait',
    alt: 'Serpme Köy Kahvaltısı',
    category: 'Kahvaltı',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Beautiful%20Mediterranean%20coastal%20landscape%20Marmaris%20Orhaniye%20region%20turquoise%20calm%20sea%20green%20hills%20small%20bay%20yachts%20docked%20warm%20golden%20sunlight%20serene%20peaceful%20atmosphere%20editorial%20travel%20photography%20high%20detail%20natural%20beauty%20Aegean%20coast%20Turkey&width=600&height=800&seq=gal-orhaniye-01&orientation=portrait',
    alt: 'Orhaniye Manzarası',
    category: 'Orhaniye',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=World%20famous%20Kizkumu%20beach%20in%20Marmaris%20Orhaniye%20shallow%20turquoise%20water%20sand%20bar%20stretching%20into%20sea%20people%20walking%20warm%20summer%20afternoon%20light%20serene%20beautiful%20coastal%20scene%20editorial%20travel%20photography%20high%20detail%20natural%20Aegean%20beauty%20Turkey&width=600&height=800&seq=gal-kizkumu-01&orientation=portrait',
    alt: 'Kız Kumu Plajı',
    category: 'Kız Kumu',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Boutique%20hotel%20outdoor%20relaxation%20area%20with%20comfortable%20white%20lounge%20chairs%20under%20olive%20trees%20soft%20cushions%20wooden%20deck%20greenery%20surroundings%20warm%20late%20afternoon%20light%20serene%20peaceful%20atmosphere%20editorial%20travel%20photography%20high%20detail%20natural%20garden%20setting&width=600&height=800&seq=gal-lounge-01&orientation=portrait',
    alt: 'Dinlenme Alanları',
    category: 'Dinlenme',
  },
  {
    src: 'https://readdy.ai/api/search-image?query=Spacious%20family%20hotel%20room%20interior%20with%20living%20area%20small%20kitchenette%20natural%20wood%20furniture%20olive%20green%20beige%20decor%20tones%20large%20window%20garden%20view%20warm%20natural%20light%20clean%20boutique%20hotel%20aesthetic%20editorial%20interior%20photography%20high%20detail%20comfortable%20home%20atmosphere&width=600&height=800&seq=gal-family-01&orientation=portrait',
    alt: '1+1 Aile Odası',
    category: 'Odalar',
  },
];

const categories = ['Tümü', 'Otel', 'Odalar', 'Havuz', 'Kahvaltı', 'Orhaniye', 'Kız Kumu', 'Dinlenme'];

export default function GallerySection() {
  const [activeCategory, setActiveCategory] = useState('Tümü');
  const [lightbox, setLightbox] = useState<GalleryImage | null>(null);

  const { ref: headerRef, isVisible: headerVisible } = useScrollReveal({ threshold: 0.2 });
  const { ref: gridRef, isVisible: gridVisible } = useScrollReveal({ threshold: 0.05 });

  const filtered = activeCategory === 'Tümü'
    ? galleryImages
    : galleryImages.filter((img) => img.category === activeCategory);

  return (
    <section id="galeri" className="w-full py-16 md:py-24 px-4 md:px-8 lg:px-12 bg-background-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div ref={headerRef} className={`text-center mb-8 md:mb-12 transition-all duration-700 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            İlkim Butik Otel'den <span className="text-primary-500">Kareler</span>
          </h2>
        </div>

        {/* Categories */}
        <div className={`flex flex-wrap justify-center gap-2 mb-8 md:mb-10 transition-all duration-700 delay-200 ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer hover:scale-105 active:scale-95 ${
                activeCategory === cat
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/60'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Grid */}
        <div ref={gridRef} className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {filtered.map((img, i) => (
            <button
              key={img.src}
              onClick={() => setLightbox(img)}
              className={`relative group rounded-2xl overflow-hidden aspect-[3/4] cursor-pointer text-left transition-all duration-500 hover:shadow-lg hover:scale-[1.02] ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${i * 80}ms` }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <span className="absolute top-3 left-3 px-2.5 py-1 bg-background-50/90 backdrop-blur-sm rounded-full text-xs font-medium text-foreground-700 transition-transform duration-300 group-hover:scale-105">
                {img.category}
              </span>
              <span className="absolute bottom-3 left-3 right-3 text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {img.alt}
              </span>
            </button>
          ))}
        </div>

        {/* CTA */}
        <div className={`text-center mt-8 md:mt-10 transition-all duration-700 delay-300 ${gridVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <a
            href="https://wa.me/905395851199?text=Merhaba%2C%20İlkim%20Butik%20Otel%20için%20bu%20atmosferde%20tatil%20fiyat%20ve%20müsaitlik%20bilgisi%20almak%20istiyorum.%20Fiyat%20teklifi%20alabilir%20miyim%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-5 py-3 bg-primary-500 text-background-50 rounded-xl font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer hover:scale-[1.02] active:scale-[0.98]"
          >
            <i className="ri-whatsapp-line" />
            Bu Atmosfer İçin Fiyat Bilgisi Al
          </a>
        </div>
      </div>

      {/* Lightbox */}
      {lightbox && (
        <div
          className="fixed inset-0 z-[60] bg-black/90 flex items-center justify-center p-4 md:p-8 animate-fade-in"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center text-white/80 hover:text-white rounded-full bg-white/10 cursor-pointer hover:bg-white/20 transition-all"
            onClick={() => setLightbox(null)}
          >
            <i className="ri-close-line text-2xl" />
          </button>
          <div className="max-w-4xl max-h-[90vh] w-full flex flex-col items-center animate-scale-in">
            <img
              src={lightbox.src}
              alt={lightbox.alt}
              className="max-w-full max-h-[80vh] object-contain rounded-xl"
              onClick={(e) => e.stopPropagation()}
            />
            <p className="mt-4 text-white text-sm font-medium">{lightbox.alt}</p>
          </div>
        </div>
      )}
    </section>
  );
}